<template>
    <div>
      <Head title="Crear tasa de cambio" />
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/taxes">Tasas de cambio</Link>
        <span class="text-indigo-400 font-medium">/</span> Crear
      </h1>
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="store">
          <div class="flex flex-wrap items-end -mb-8 -mr-6 p-8">
            <div class="w-full lg:w-1/2 pr-6 pb-8">
              <text-input type="number" step="0.00000001" v-model="form.change" :error="form.errors.change" label="Tasa de cambio" />
            </div>
            <div class="w-full lg:w-1/2 pr-6 pb-8 flex space-x-2">
              <button 
                type="button" 
                @click="fetchRate('usd')" 
                :disabled="fetching"
                class="px-4 py-2 border border-gray-300 rounded shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 transition-colors duration-200"
              >
                {{ fetching && fetchingType === 'usd' ? 'Consultando...' : 'Obtener BCV USD' }}
              </button>
              <button 
                type="button" 
                @click="fetchRate('eur')" 
                :disabled="fetching"
                class="px-4 py-2 border border-gray-300 rounded shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 transition-colors duration-200"
              >
                {{ fetching && fetchingType === 'eur' ? 'Consultando...' : 'Obtener BCV Euro' }}
              </button>
            </div>
          </div>
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-blue">Crear tasa de cambio</loading-button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Layout from '@/Shared/Layout'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'
  
  export default {
    components: {
      Head,
      Link,
      LoadingButton,
      TextInput,
    },
    layout: Layout,
    remember: 'form',
    data() {
      return {
        fetching: false,
        fetchingType: null,
        form: this.$inertia.form({
          change: 0
        }),
      }
    },
    methods: {
      store() {
        this.form.post('/taxes')
      },
      fetchRate(type) {
        this.fetching = true
        this.fetchingType = type
        fetch(`/taxes/rate?type=${type}`)
          .then(response => {
            if (!response.ok) {
              throw new Error('Error al obtener la tasa')
            }
            return response.json()
          })
          .then(data => {
            if (data && data.rate) {
              this.form.change = data.rate
            } else {
              alert('No se pudo obtener la tasa desde el BCV.')
            }
          })
          .catch(error => {
            console.error(error)
            alert('Hubo un error al conectar con el servidor.')
          })
          .finally(() => {
            this.fetching = false
            this.fetchingType = null
          })
      }
    },
  }
  </script>
  
  